// const axios = require("axios")
import axios from 'axios';
const api = `${process.env.REACT_APP_API_URL}/api/v1/user/`

// Options
export async function Options() {
    const response = await axios.get(`${api}options`)
    return response.data
}